import { PrimaryButton } from "@/components/buttons/PrimaryButton";
import { PencomRoutes } from "@/router/PencomRoutes";
import { useAuthStore } from "@/stores/authStore";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useAnalytics } from "@/hooks/useAnalytics";

const OnboardingCompletionPage = () => {
    const navigate = useNavigate();
    const data = useLocation().state as {
        user?: unknown;
        authorizedContacts?: {
            fullName: string;
            role: string;
            email: string;
            phoneNumber: string;
            alternateContact?: string;
            preferredChannel: string;
            consentGiven: boolean;
        }[];
        employer?: {
            employerCode: string;
            companyName: string;
        };
        phoneNumber?: string;
        email?: string;
    } | null;

    const authenticate = useAuthStore((state) => state.login);
    const { trackEvent, eventNames } = useAnalytics();

    const handleSignIn = () => {
        if (data?.employer) authenticate(data.employer);
        trackEvent(eventNames.onboardingStepSubmitted, {
            step: "onboarding_complete",
            action: "sign_in",
        });
        navigate(PencomRoutes.DASHBOARD);
    };

    const employerCode = data?.employer?.employerCode ?? '';
    const rep = data?.authorizedContacts?.[0];

    useEffect(() => {
        trackEvent(eventNames.onboardingPageView, {
            step: "onboarding_complete",
        });
    }, []);

    return (
        <div className="w-full flex flex-col">
            <div className="flex flex-col items-center gap-4 mt-15.5">
                <img src="/assets/icons/solid-check.svg" className="size-10" alt="" aria-hidden />
                <h2 className="font-clash-display font-semibold text-2xl text-medium-dark-grey text-center tracking-[-0.36px] leading-[1.25]">
                    Registration Successful
                </h2>
            </div>

            <p className="font-clash-display font-normal text-sm text-medium-dark-grey leading-[18px] tracking-[-0.07px] mt-6">
                Your employer account has been successfully created and linked to Employer Code{' '}
                <span className="font-semibold">{employerCode}</span>.
            </p>

            <div className="bg-white border border-stroke rounded-lg overflow-hidden mt-6 grid grid-cols-2 gap-x-6 gap-y-6 p-4">
                <div className="flex flex-col gap-1">
                    <p className="font-clash-display font-normal text-sm text-medium-dark-grey">Employer Code</p>
                    <p className="font-clash-display font-semibold text-sm leading-6 text-medium-dark-grey">{employerCode}</p>
                </div>
                <div className="flex flex-col gap-1">
                    <p className="font-clash-display font-normal text-sm text-medium-dark-grey">Authorise Representative</p>
                    <p className="font-clash-display font-semibold text-sm leading-6 text-medium-dark-grey">{rep?.fullName ?? '—'}</p>
                </div>
                <div className="flex flex-col gap-1">
                    <p className="font-clash-display font-normal text-sm text-medium-dark-grey">Registered Phone Number</p>
                    <p className="font-clash-display font-semibold text-sm leading-6 text-medium-dark-grey">{rep?.phoneNumber ?? '—'}</p>
                </div>
                <div className="flex flex-col gap-1">
                    <p className="font-clash-display font-normal text-sm text-medium-dark-grey">Registered Email Address</p>
                    <p className="font-clash-display font-semibold text-sm leading-6 text-medium-dark-grey">{rep?.email ?? '—'}</p>
                </div>
            </div>

            <p className="font-clash-display font-normal text-sm text-medium-dark-grey leading-[18px] tracking-[-0.07px] mt-6">
                You can now sign in to eHub using one-time codes sent to your registered email address.
            </p>

            <PrimaryButton className="w-full mt-8" title="Sign in to eHub" onClick={handleSignIn} />
        </div>
    );
};

export default OnboardingCompletionPage;
